(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["f5-header"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('[data-package]').forEach(function(link){link.addEventListener('click',function(){var select=document.getElementById('f5-package');if(select){if(!Array.from(select.options).some(function(option){return option.value===link.dataset.package;})){select.add(new Option(link.dataset.package,link.dataset.package));}select.value=link.dataset.package;}});});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f5-us-services"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-package]').forEach(function(link){link.addEventListener('click',function(){var select=document.getElementById('f5-package');if(select){select.value=link.dataset.package;}});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
